/**
 * State
 */
const state = {
    availablePaymentMethods: [
        'klarna',
        'klarna-instalments',
        'braintree'
    ],
    paymentMethod: null,

    // Refactor to retrieve from booking module once implemented
    klarnaSdkIsAvailable: false
};

/**
 * Getters
 */
const getters = {
    /** Returns the currently selected payment method */
    paymentMethod: state => state.paymentMethod,

    /** Determines if the supplied paymentMethod matches the currently selected one */
    paymentMethodIsSelected: state => paymentMethod => state.paymentMethod === paymentMethod,

    /**
     * Braintree
     */
    /** Retrieves the Braintree Token */
    braintreeToken: (getters, rootGetters) => rootGetters.booking.braintree_client_token,

    /**
     * Klarna
     */
    /** Retrieves the Klarna Session Id */
    klarnaSessionId: (getters, rootGetters) => rootGetters.booking.klarna_session_id,

    /** Retrieves the Klarna Client Token */
    klarnaClientToken: (getters, rootGetters) => rootGetters.booking.klarna_client_token,

    /** Determines if the SDK is available so we can initialise the Klarna payment methods */
    klarnaSdkIsAvailable: state => state.klarnaSdkIsAvailable,
};

/**
 * Actions
 */
const actions = {
    /**
     * General
     */
    /** Sets the requested payment method and unsets if it is currently selected */
    setPaymentMethod({state, commit, getters}, paymentMethod) {
        return new Promise((resolve) => {
            if (paymentMethod && state.availablePaymentMethods.includes(paymentMethod)) {
                if(getters.paymentMethodIsSelected(paymentMethod)) {
                    commit('SET_PAYMENT_METHOD', null);
                    return;
                }
                commit('SET_PAYMENT_METHOD', paymentMethod);
            }

            resolve();
        });
    },

    /**
     * Klarna
     */
    /** Used to notify the SDK widgets that the SDK has been loaded and that they can now be initialised */
    setKlarnaSdkAsAvailable({commit}) {
        commit('SET_KLARNA_SDK_AVAILABLE');
    },

    generateBillingTokens({commit, rootGetters}) {
        return new Promise((resolve, reject) => {
            this.$axios.post(`/api/v4/wefix-booking/${rootGetters.booking.reference}/generate-billing-tokens`)
                .then(response => {
                    commit('SET_BOOKING_FROM_RESPONSE', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /** We need to pass the customer information to Klarna in order for them to authorise the payment */
    syncCustomerDetailsWithKlarna() {
        // TODO: Point to wefix-bookings equivalent
        // return new Promise((resolve, reject) => {
        //     axios.post(`${apiUrl}/api/v4/booking/${getters.bookingReference}/update-customer-details?key=${getters.apiKey}`, state.booking)
        //         .then(response => {
        //             commit('SET_BOOKING', response.data.data);
        //             resolve();
        //         })
        //         .catch(error => {
        //             reject(error);
        //         });
        // });
        return new Promise((resolve) => {
            resolve();
        });
    }
};

/**
 * Mutations
 */
const mutations = {
    /**
     * General
     */
    /** Set the current payment method */
    SET_PAYMENT_METHOD(state, paymentMethod) {
        state.paymentMethod = paymentMethod;
    },

    /**
     * Klarna
     */
    SET_KLARNA_SDK_AVAILABLE(state) {
        state.klarnaSdkIsAvailable = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}